import axios, { AxiosInstance } from 'axios';
import { Endpoints } from '../endpoints';

export interface Document {
  id: string;
  fileName: string;
}

export interface DocumentObject {
  s3Prefix: string;
  fileName: string;
  notes?: string;
}

export interface CreateDocumentRequest {
  documents: DocumentObject[];
}

export interface CreateDocumentResponse {}

/**
 * C2-4431 Creates a document storage record in the DB with a link to the
 * presigned url and the original filename. It will be associated to the CLAIM
 * which relates to the user account.
 *
 * @param params.fileName - original filename for the document being stored.
 * @param params.s3Prefix - s3Prefix from document to be stored in DB document_storage DOC_NAME
 * @param instance - Axios instance that will be used to query the API.
 * @returns - document_storage_id for the newly created document entry.
 */
export const createDocument = async (
  data: CreateDocumentRequest,
  instance: AxiosInstance = axios,
) => instance.post(Endpoints.Document.CREATE, data);

export interface GetPresignedUrlRequest {
  fileName: string;
}

/**
 * C2-4430
 * @param instance - Axios instance that will be used to query the API.
 * @returns Gets a presigned URL with its key.
 */
export const getPresignedUrl = async (
  req: GetPresignedUrlRequest,
  instance: AxiosInstance = axios,
) => {
  return instance.get(Endpoints.Document.GET_PRESIGNED_URL, { params: req });
};

/**
 * C2-4557
 * @param instance - Axios instance that will be used to query the API.
 * @returns Gets a presigned download URL with its key.
 */
export interface GetPresignedDownloadUrlRequest {
  docStorageId: string;
}
export const getPresignedUrlDownload = async (
  req: GetPresignedDownloadUrlRequest,
  instance: AxiosInstance = axios,
) => {
  return instance.get(Endpoints.Document.GET_PRESIGNED_URL_DOWNLOAD, { params: req });
};

export interface GetUploadedDocsRequest {}
export interface UserDocument {
  fileName: string;
  docStorageId: string;
  docName: string;
  isDeletable: number;
}

export const getUserDocs = async (req: GetUploadedDocsRequest, instance: AxiosInstance = axios) =>
  instance.get<UserDocument[]>(Endpoints.Document.GET_UPLOADED_DOCS, { params: req });

export interface DeleteUploadedDocsRequest {
  docStorageId: string;
}
export interface DeleteUserDocument {
  docStorageId: string;
}

export const deleteUserDocs = async (
  req: DeleteUploadedDocsRequest,
  instance: AxiosInstance = axios,
) =>
  instance.delete(Endpoints.Document.DELETE_UPLOADED_DOCS.replace('{id}', `${req.docStorageId}`), {
    params: req,
  });
